import { Container } from "@mui/material";
import SimpleHeader from "./SimpleHeader.js";
import { useOutletContext } from "react-router-dom";

/**
 * A page under a SimpleHeader. Narrow (`sm`) by default, suiting settings and
 * reading pages; `maxWidth="lg"` matches Track's width, for wider content.
 */
export default function LayoutWithHeader({
  title,
  titleAdornment,
  children,
  showBackButton = false,
  showMenu = true,
  maxWidth = "sm",
}) {
  const { toggleDrawer, drawerWidth } = useOutletContext();

  return (
    <Container maxWidth={maxWidth} sx={{ pb: 14, px: 0 }}>
      <SimpleHeader
        toggleDrawer={toggleDrawer}
        drawerWidth={drawerWidth}
        title={title}
        titleAdornment={titleAdornment}
        showBackButton={showBackButton}
        showMenu={showMenu}
        maxWidth={maxWidth}
      />

      {children}
    </Container>
  );
}
